import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import ChartDataLabels from "chartjs-plugin-datalabels"

export default class extends Controller {
  static values = {
    type: String,
    labels: Array,
    data: Array,
    showCurrency: Boolean
  }

  connect() {
    this.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }

  render() {
    const ctx = this.element.getContext("2d")

    this.chart = new Chart(ctx, {
      type: this.typeValue || "pie",
      data: {
        labels: this.labelsValue,
        datasets: [{
          data: this.dataValue,
          backgroundColor: this.generateColors(this.labelsValue.length)
        }]
      },
      plugins: [ChartDataLabels],
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "bottom"
          },
          datalabels: {
            color: "#fff",
            font: { weight: "bold" },
            formatter: (value, context) => {
              const total = context.chart.data.datasets[0].data
                .reduce((a, b) => a + b, 0)

              const percentage = ((value / total) * 100).toFixed(1)

              if (this.showCurrencyValue) {
                return `${this.formatCurrency(value)}\n(${percentage}%)`
              }

              return `${value}\n(${percentage}%)`
            }
          }
        }
      }
    })
  }

  formatCurrency(value) {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR"
    }).format(value)
  }

  generateColors(count) {
    const palette = [
      "#2563eb",
      "#16a34a",
      "#dc2626",
      "#ca8a04",
      "#9333ea",
      "#0d9488",
      "#ea580c"
    ]

    return Array.from({ length: count }, (_, i) =>
      palette[i % palette.length]
    )
  }
}
